var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastboardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 14,
    viewBox: "0 0 71 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77734 6.40625V3.38281H7.85547V1.54688H0.433594V12.9219H2.77734V8.23438H7.30859V6.40625H2.77734Z",
    fill: "url(#paint0_linear_15792_12276)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4606 12.1282C13.3808 12.2207 13.2936 12.3108 13.1992 12.3984C12.9805 12.5964 12.7174 12.7604 12.4102 12.8906C12.1029 13.0156 11.7383 13.0781 11.3164 13.0781C10.7799 13.0781 10.293 12.9714 9.85547 12.7578C9.42318 12.5391 9.07943 12.2396 8.82422 11.8594C8.57422 11.474 8.44922 11.0365 8.44922 10.5469C8.44922 10.1042 8.53255 9.71094 8.69922 9.36719C8.86589 9.02344 9.11068 8.73438 9.43359 8.5C9.76172 8.26042 10.1706 8.08073 10.6602 7.96094C11.1497 7.83594 11.7174 7.77344 12.3633 7.77344H13.3711V7.25C13.3711 6.97917 13.3268 6.7474 13.2383 6.55469C13.1497 6.35677 13.0117 6.20312 12.8242 6.09375C12.6419 5.98438 12.4049 5.92969 12.1133 5.92969C11.8633 5.92969 11.6471 5.97396 11.4648 6.0625C11.2826 6.14583 11.1419 6.26823 11.043 6.42969C10.944 6.58594 10.8945 6.77083 10.8945 6.98438H8.64453C8.64453 6.625 8.72786 6.28385 8.89453 5.96094C9.0612 5.63802 9.30339 5.35417 9.62109 5.10938C9.9388 4.85938 10.3164 4.66406 10.7539 4.52344C11.1966 4.38281 11.6914 4.3125 12.2383 4.3125C12.8945 4.3125 13.4779 4.42188 13.9883 4.64062C14.4987 4.85938 14.8997 5.1875 15.1914 5.625C15.4883 6.0625 15.6367 6.60938 15.6367 7.26562V10.8828C15.6367 11.3464 15.6654 11.7266 15.7227 12.0234C15.7799 12.3151 15.8633 12.5703 15.9727 12.7891V12.9219H13.6992C13.5969 12.7075 13.5173 12.4429 13.4606 12.1282ZM13.3711 10.5327C13.3425 10.5861 13.3086 10.6403 13.2695 10.6953C13.1341 10.8932 12.9414 11.0599 12.6914 11.1953C12.4414 11.3307 12.1471 11.3984 11.8086 11.3984C11.5846 11.3984 11.3893 11.3568 11.2227 11.2734C11.056 11.1849 10.9284 11.0651 10.8398 10.9141C10.7513 10.7578 10.707 10.5833 10.707 10.3906C10.707 10.1979 10.7383 10.0208 10.8008 9.85938C10.8685 9.69792 10.9727 9.55729 11.1133 9.4375C11.2539 9.3125 11.4336 9.21615 11.6523 9.14844C11.8711 9.08073 12.1289 9.04688 12.4258 9.04688H13.3711V10.5327Z",
    fill: "url(#paint1_linear_15792_12276)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8008 10.1484C21.8945 10.2786 21.9414 10.4245 21.9414 10.5859C21.9414 10.7682 21.8893 10.9297 21.7852 11.0703C21.6862 11.2057 21.5404 11.3151 21.3477 11.3984C21.1549 11.4766 20.9128 11.5156 20.6211 11.5156C20.3503 11.5156 20.0977 11.474 19.8633 11.3906C19.6341 11.3073 19.444 11.1719 19.293 10.9844C19.1471 10.7969 19.069 10.5495 19.0586 10.2422H16.9258C16.9258 10.7005 17.0638 11.1484 17.3398 11.5859C17.6211 12.0182 18.0326 12.375 18.5742 12.6562C19.1211 12.9375 19.7878 13.0781 20.5742 13.0781C21.1159 13.0781 21.6029 13.0156 22.0352 12.8906C22.4727 12.7604 22.8477 12.5807 23.1602 12.3516C23.4727 12.1172 23.7122 11.8438 23.8789 11.5312C24.0456 11.2188 24.1289 10.875 24.1289 10.5C24.1289 9.94792 23.9883 9.5026 23.707 9.16406C23.4258 8.82031 23.0456 8.54948 22.5664 8.35156C22.0872 8.14844 21.543 7.98438 20.9336 7.85938C20.6367 7.80208 20.3867 7.73958 20.1836 7.67188C19.9857 7.59896 19.8242 7.52083 19.6992 7.4375C19.5742 7.35417 19.4831 7.26302 19.4258 7.16406C19.3737 7.0599 19.3477 6.94271 19.3477 6.8125C19.3477 6.64062 19.3945 6.48438 19.4883 6.34375C19.5872 6.19792 19.7279 6.08333 19.9102 6C20.0924 5.91146 20.3086 5.86719 20.5586 5.86719C20.8607 5.86719 21.1055 5.91927 21.293 6.02344C21.4857 6.1224 21.6263 6.26042 21.7148 6.4375C21.8086 6.60938 21.8555 6.80469 21.8555 7.02344H24.1055C24.1055 6.5026 23.9622 6.03906 23.6758 5.63281C23.3945 5.22135 22.9883 4.89844 22.457 4.66406C21.931 4.42969 21.3008 4.3125 20.5664 4.3125C20.0404 4.3125 19.5664 4.38281 19.1445 4.52344C18.7279 4.65885 18.3737 4.84896 18.082 5.09375C17.7956 5.33333 17.5742 5.60938 17.418 5.92188C17.2669 6.23438 17.1914 6.56771 17.1914 6.92188C17.1914 7.28125 17.2669 7.60156 17.418 7.88281C17.569 8.15885 17.7773 8.39844 18.043 8.60156C18.3138 8.80469 18.6315 8.97917 18.9961 9.125C19.3659 9.26562 19.7643 9.38281 20.1914 9.47656C20.6654 9.57031 21.0273 9.67448 21.2773 9.78906C21.5326 9.89844 21.707 10.0182 21.8008 10.1484Z",
    fill: "url(#paint2_linear_15792_12276)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7305 6.0625V4.46875H28.2773V2.38281H26.0273V4.46875H24.8086V6.0625H26.0273V10.6016C26.0273 11.1953 26.1263 11.6745 26.3242 12.0391C26.5221 12.4036 26.8034 12.6693 27.168 12.8359C27.5378 12.9974 27.9701 13.0781 28.4648 13.0781C28.7357 13.0781 28.9831 13.0599 29.207 13.0234C29.431 12.987 29.6393 12.9375 29.832 12.875L29.8242 11.2188C29.7461 11.2344 29.6497 11.25 29.5352 11.2656C29.4258 11.276 29.3008 11.2812 29.1602 11.2812C28.9622 11.2812 28.7982 11.2578 28.668 11.2109C28.5378 11.1589 28.4388 11.0677 28.3711 10.9375C28.3086 10.8073 28.2773 10.6198 28.2773 10.375V6.0625H29.7305Z",
    fill: "url(#paint3_linear_15792_12276)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2617 0.921875H31.0117V12.9219H33.0352L33.1406 12.0202C33.3772 12.3346 33.6597 12.5831 33.9883 12.7656C34.3685 12.974 34.8164 13.0781 35.332 13.0781C35.8841 13.0781 36.3633 12.974 36.7695 12.7656C37.181 12.5521 37.5247 12.2552 37.8008 11.875C38.0768 11.4896 38.2799 11.0339 38.4102 10.5078C38.5456 9.98177 38.6133 9.40365 38.6133 8.77344V8.60938C38.6133 7.97917 38.5456 7.40365 38.4102 6.88281C38.2799 6.35677 38.0768 5.90365 37.8008 5.52344C37.5299 5.13802 37.1862 4.84115 36.7695 4.63281C36.3581 4.41927 35.8737 4.3125 35.3164 4.3125C34.806 4.3125 34.3633 4.41667 33.9883 4.625C33.7141 4.77734 33.4719 4.97563 33.2617 5.21988V0.921875ZM33.2617 10.4126V6.98479C33.3129 6.87113 33.3728 6.76683 33.4414 6.67188C33.582 6.48438 33.7591 6.33854 33.9727 6.23438C34.1862 6.13021 34.4466 6.07812 34.7539 6.07812C35.0768 6.07812 35.3398 6.14583 35.543 6.28125C35.7513 6.41667 35.9154 6.60156 36.0352 6.83594C36.1549 7.0651 36.2383 7.33333 36.2852 7.64062C36.3372 7.94271 36.3633 8.26562 36.3633 8.60938V8.77344C36.3633 9.13802 36.3398 9.47656 36.293 9.78906C36.2461 10.0964 36.1628 10.3646 36.043 10.5938C35.9284 10.8229 35.7669 11 35.5586 11.125C35.3503 11.25 35.0872 11.3125 34.7695 11.3125C34.3633 11.3125 34.0326 11.224 33.7773 11.0469C33.5569 10.8861 33.385 10.6747 33.2617 10.4126Z",
    fill: "url(#paint4_linear_15792_12276)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6523 8.61719V8.78125C39.6523 9.39583 39.7409 9.96615 39.918 10.4922C40.0951 11.013 40.3529 11.4688 40.6914 11.8594C41.0352 12.2448 41.4544 12.5443 41.9492 12.7578C42.4492 12.9714 43.0195 13.0781 43.6602 13.0781C44.3008 13.0781 44.8685 12.9714 45.3633 12.7578C45.8581 12.5443 46.2747 12.2448 46.6133 11.8594C46.957 11.4688 47.2174 11.013 47.3945 10.4922C47.5716 9.96615 47.6602 9.39583 47.6602 8.78125V8.61719C47.6602 7.9974 47.5716 7.42708 47.3945 6.90625C47.2174 6.38021 46.957 5.92448 46.6133 5.53906C46.2747 5.15365 45.8555 4.85417 45.3555 4.64062C44.8555 4.42188 44.2852 4.3125 43.6445 4.3125C43.0039 4.3125 42.4362 4.42188 41.9414 4.64062C41.4466 4.85417 41.0299 5.15365 40.6914 5.53906C40.3529 5.92448 40.0951 6.38021 39.918 6.90625C39.7409 7.42708 39.6523 7.9974 39.6523 8.61719ZM41.9023 8.78125V8.61719C41.9023 8.27344 41.9336 7.95052 41.9961 7.64844C42.0586 7.34115 42.1576 7.07031 42.293 6.83594C42.4336 6.59635 42.6133 6.40885 42.832 6.27344C43.056 6.13802 43.3268 6.07031 43.6445 6.07031C43.9622 6.07031 44.2331 6.13802 44.457 6.27344C44.681 6.40885 44.8607 6.59635 44.9961 6.83594C45.1367 7.07031 45.2383 7.34115 45.3008 7.64844C45.3685 7.95052 45.4023 8.27344 45.4023 8.61719V8.78125C45.4023 9.13542 45.3685 9.46615 45.3008 9.77344C45.2383 10.0807 45.1393 10.3516 45.0039 10.5859C44.8685 10.8151 44.6888 10.9948 44.4648 11.125C44.2409 11.2552 43.9727 11.3203 43.6602 11.3203C43.3372 11.3203 43.0638 11.2552 42.8398 11.125C42.6159 10.9948 42.4336 10.8151 42.293 10.5859C42.1576 10.3516 42.0586 10.0807 41.9961 9.77344C41.9336 9.46615 41.9023 9.13542 41.9023 8.78125Z",
    fill: "url(#paint5_linear_15792_12276)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.695 12.1282C53.6151 12.2207 53.528 12.3108 53.4336 12.3984C53.2148 12.5964 52.9518 12.7604 52.6445 12.8906C52.3372 13.0156 51.9727 13.0781 51.5508 13.0781C51.0143 13.0781 50.5273 12.9714 50.0898 12.7578C49.6576 12.5391 49.3138 12.2396 49.0586 11.8594C48.8086 11.474 48.6836 11.0365 48.6836 10.5469C48.6836 10.1042 48.7669 9.71094 48.9336 9.36719C49.1003 9.02344 49.3451 8.73438 49.668 8.5C49.9961 8.26042 50.4049 8.08073 50.8945 7.96094C51.3841 7.83594 51.9518 7.77344 52.5977 7.77344H53.6055V7.25C53.6055 6.97917 53.5612 6.7474 53.4727 6.55469C53.3841 6.35677 53.2461 6.20312 53.0586 6.09375C52.8763 5.98438 52.6393 5.92969 52.3477 5.92969C52.0977 5.92969 51.8815 5.97396 51.6992 6.0625C51.5169 6.14583 51.3763 6.26823 51.2773 6.42969C51.1784 6.58594 51.1289 6.77083 51.1289 6.98438H48.8789C48.8789 6.625 48.9622 6.28385 49.1289 5.96094C49.2956 5.63802 49.5378 5.35417 49.8555 5.10938C50.1732 4.85938 50.5508 4.66406 50.9883 4.52344C51.431 4.38281 51.9258 4.3125 52.4727 4.3125C53.1289 4.3125 53.7122 4.42188 54.2227 4.64062C54.7331 4.85938 55.1341 5.1875 55.4258 5.625C55.7227 6.0625 55.8711 6.60938 55.8711 7.26562V10.8828C55.8711 11.3464 55.8997 11.7266 55.957 12.0234C56.0143 12.3151 56.0977 12.5703 56.207 12.7891V12.9219H53.9336C53.8313 12.7075 53.7517 12.4429 53.695 12.1282ZM53.6055 10.5327C53.5768 10.5861 53.543 10.6403 53.5039 10.6953C53.3685 10.8932 53.1758 11.0599 52.9258 11.1953C52.6758 11.3307 52.3815 11.3984 52.043 11.3984C51.819 11.3984 51.6237 11.3568 51.457 11.2734C51.2904 11.1849 51.1628 11.0651 51.0742 10.9141C50.9857 10.7578 50.9414 10.5833 50.9414 10.3906C50.9414 10.1979 50.9727 10.0208 51.0352 9.85938C51.1029 9.69792 51.207 9.55729 51.3477 9.4375C51.4883 9.3125 51.668 9.21615 51.8867 9.14844C52.1055 9.08073 52.3633 9.04688 52.6602 9.04688H53.6055V10.5327Z",
    fill: "url(#paint6_linear_15792_12276)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8555 7.34631V12.9219H57.6055V4.46875H59.7227L59.7973 5.50454C59.8187 5.46586 59.8407 5.42789 59.8633 5.39062C60.0768 5.04688 60.3372 4.78125 60.6445 4.59375C60.9518 4.40625 61.3034 4.3125 61.6992 4.3125C61.8242 4.3125 61.9518 4.32292 62.082 4.34375C62.2122 4.35938 62.319 4.38281 62.4023 4.41406L62.3633 6.5C62.2539 6.48438 62.1211 6.47135 61.9648 6.46094C61.8138 6.44531 61.6758 6.4375 61.5508 6.4375C61.2331 6.4375 60.957 6.47917 60.7227 6.5625C60.4935 6.64062 60.3008 6.75781 60.1445 6.91406C60.0256 7.03714 59.9292 7.18122 59.8555 7.34631Z",
    fill: "url(#paint7_linear_15792_12276)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4166 12.0206C68.1751 12.3337 67.8891 12.582 67.5586 12.7656C67.1836 12.974 66.7461 13.0781 66.2461 13.0781C65.7201 13.0781 65.2513 12.9714 64.8398 12.7578C64.4336 12.5443 64.0898 12.2448 63.8086 11.8594C63.5326 11.474 63.3216 11.0208 63.1758 10.5C63.0299 9.97917 62.957 9.41146 62.957 8.79688V8.63281C62.957 7.98698 63.0299 7.40104 63.1758 6.875C63.3216 6.34375 63.5352 5.88802 63.8164 5.50781C64.0977 5.1276 64.444 4.83333 64.8555 4.625C65.2669 4.41667 65.7357 4.3125 66.2617 4.3125C66.7565 4.3125 67.1888 4.41667 67.5586 4.625C67.8377 4.78008 68.0851 4.98422 68.3008 5.23742V0.921875H70.5664V12.9219H68.5273L68.4166 12.0206ZM68.3008 6.99056C68.2452 6.87409 68.1801 6.76787 68.1055 6.67188C67.9648 6.48438 67.7878 6.33854 67.5742 6.23438C67.3659 6.13021 67.1185 6.07812 66.832 6.07812C66.5404 6.07812 66.2904 6.14583 66.082 6.28125C65.8737 6.41146 65.7044 6.59115 65.5742 6.82031C65.4492 7.04948 65.3555 7.32031 65.293 7.63281C65.2357 7.9401 65.207 8.27344 65.207 8.63281V8.79688C65.207 9.14583 65.2331 9.47135 65.2852 9.77344C65.3424 10.0755 65.4336 10.3438 65.5586 10.5781C65.6888 10.8073 65.8555 10.987 66.0586 11.1172C66.2669 11.2422 66.5195 11.3047 66.8164 11.3047C67.2018 11.3047 67.5195 11.2188 67.7695 11.0469C67.9956 10.8868 68.1727 10.6734 68.3008 10.4068V6.99056Z",
    fill: "url(#paint8_linear_15792_12276)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15792_12276",
    x1: 61.2606,
    y1: 11.8259,
    x2: 58.7138,
    y2: -5.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15792_12276",
    x1: 61.2606,
    y1: 11.8259,
    x2: 58.7138,
    y2: -5.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15792_12276",
    x1: 61.2606,
    y1: 11.8259,
    x2: 58.7138,
    y2: -5.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15792_12276",
    x1: 61.2606,
    y1: 11.8259,
    x2: 58.7138,
    y2: -5.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15792_12276",
    x1: 61.2606,
    y1: 11.8259,
    x2: 58.7138,
    y2: -5.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15792_12276",
    x1: 61.2606,
    y1: 11.8259,
    x2: 58.7138,
    y2: -5.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15792_12276",
    x1: 61.2606,
    y1: 11.8259,
    x2: 58.7138,
    y2: -5.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15792_12276",
    x1: 61.2606,
    y1: 11.8259,
    x2: 58.7138,
    y2: -5.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15792_12276",
    x1: 61.2606,
    y1: 11.8259,
    x2: 58.7138,
    y2: -5.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0109202,
    stopColor: "#00ECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2676,
    stopColor: "#0BB2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#1483EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#1A62E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#1E4DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F46E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastboardLogo);
export default __webpack_public_path__ + "static/media/fastboardLogo.1e689b8978d596d188f5076172628524.svg";
export { ForwardRef as ReactComponent };